import VaultDescriptionIcon from 'assets/images/product-tour-recording.png';
import VaultMattersIcon from 'assets/images/product-tour-sharing-and-privacy.png';
import VaultAddDescriptionIcon from 'assets/images/product-tour-store-documents.png';
import { VaultInfoCard } from '../vault-info-card/vault-info-card';
import styles from './second-section-vault-info.module.scss';

const SecondSeccionVaultInfo: React.FC = () => {
  const descriptionCard1 =
    'A safe, flexible space to preserve your story—one prompt, photo, or voice note at a time. This vault holds albums, moments, and albums that deserve to be remembered. You can add entries anytime—by video, audio, text, or upload.';
  const descriptionCard2 =
    'Add photos, voice recordings, scanned letters, or your own reflections—anything that brings your story to life.';

  const descriptionCard3 =
    'Every album added here becomes part of a lasting legacy—something loved ones and future generations can look back on and cherish.';

  return (
    <div className={styles.content}>
      <VaultInfoCard
        title="What is a Vault?"
        description={descriptionCard1}
        icon={
          <img
            src={VaultDescriptionIcon}
            alt="Avatar"
            className={styles.cartItemImage}
          />
        }
        isIconRightAligned
      />
      <VaultInfoCard
        title="What can I add?"
        description={descriptionCard2}
        icon={
          <img
            src={VaultAddDescriptionIcon}
            alt="Avatar"
            className={styles.cartItemImage}
          />
        }
        isIconRightAligned={false}
      />
      <VaultInfoCard
        title="Why it matters"
        description={descriptionCard3}
        icon={
          <img
            src={VaultMattersIcon}
            alt="Avatar"
            className={styles.cartItemImage}
          />
        }
        isIconRightAligned
      />
    </div>
  );
};

export { SecondSeccionVaultInfo };
